export default function Main({ children }) {
  return <main className="">{children}</main>;
}
